module.exports = __webpack_public_path__ + "assets/ba90ade5588132d703f7572d67e4c77b.mp3";